module.exports = __webpack_public_path__ + "static/media/icon_service_telegram.8f43d4bc.svg";